import type { CSSProperties } from 'react';

import type { GroupBase, MenuProps } from 'react-select-5';

import ArrowTopMini from 'components/shared/Icon/icons/ArrowTopMini';
import EnterIcon from 'components/shared/Icon/icons/EnterIcon';
import Tooltip from 'components/shared/Tooltip';

import { CreateOption } from '../CreateOption';
import s from './index.module.css';

export function Menu<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: MenuProps<Option, IsMulti, Group> & { hideHint?: boolean; hideFakeCreateOption?: boolean }) {
  const { innerProps, children, getClassNames, getStyles } = props;
  return (
    <div {...innerProps} className={getClassNames('menu', props)} style={getStyles('menu', props) as CSSProperties}>
      {children}

      {/* @ts-expect-error TOFIX: Add creatable prop to the type */}
      {props.selectProps.creatable && props.selectProps.inputValue === '' && !props.hideFakeCreateOption && (
        <>
          <div className={s.fakeCreateOption} data-tip data-for={`${props.selectProps.name}-create`}>
            <CreateOption />
          </div>
          <Tooltip place="top" id={`${props.selectProps.name}-create`}>
            Enter a name to create a new option
          </Tooltip>
        </>
      )}

      {!props.hideHint && (
        <div className={s.hint}>
          <div className={s.hintItem}>
            <ArrowTopMini width="1.4rem" height="1.4rem" />
            <span>to navigate</span>
          </div>
          <div className={s.hintItem} style={{ gridColumnStart: 3 }}>
            <EnterIcon width="1.4rem" height="1.4rem" stroke="currentColor" />
            <span>to select</span>
          </div>
          <div className={s.hintItem} style={{ gridColumnStart: 5 }}>
            <span className={s.bold}>esc</span>
            <span>to dismiss</span>
          </div>
        </div>
      )}
    </div>
  );
}
